<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import { computed } from 'vue'
import PublicLayout from '@/layouts/PublicLayout.vue'

const route = useRoute()
const isAdmin = computed(() => route.path.startsWith('/admin'))
</script>

<template>
  <RouterView v-if="isAdmin" />
  <PublicLayout v-else>
    <RouterView v-slot="{ Component, route: current }">
      <Transition name="page" mode="out-in">
        <div :key="current.path"><component :is="Component" /></div>
      </Transition>
    </RouterView>
  </PublicLayout>
</template>
